import { getField, Locales } from "@simplyk/common";
import { v4 } from "uuid";

import { PrizeFormData } from "./types";

import { TicketingOutput } from "@/common/types/trpc";

export const MAX_PRIZE_TITLE_LENGTH = 60;

type SavedPrize = NonNullable<TicketingOutput["prizes"]>[number];

export const buildEmptyPrize = (title = ""): PrizeFormData => ({
  id: v4(),
  title,
  value: null,
  description: "",
  photoUrl: null,
  isHidden: false,
});

export const toPrizeFormData = (prize: SavedPrize, locale: Locales): PrizeFormData => {
  const prizeField = getField(prize.prizeFields, locale);
  return {
    id: prize.id,
    title: prizeField?.title ?? "",
    value: prize.value,
    description: prizeField?.description ?? "",
    photoUrl: prize.photoUrl,
    isHidden: prize.isHidden,
  };
};

export const toPrizeInput = (prize: PrizeFormData) => ({
  id: prize.id,
  title: prize.title.trim(),
  value: prize.value,
  description: prize.description || null,
  photoUrl: prize.photoUrl,
  isHidden: prize.isHidden,
});
